/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import { calculateDiscountComboItemSchema } from "./calculateDiscountComboItemSchema.ts";

export const calculateDiscountComboGroupSchema = z.object({
	id: z.uuid(),
	item: calculateDiscountComboItemSchema.describe("Уменьшение стоимости модификаторов позиции на бесплатные единицы."),
});
